import { render, staticRenderFns } from "./drivingLicense.vue?vue&type=template&id=6450b1ec&scoped=true"
import script from "./drivingLicense.vue?vue&type=script&lang=js"
export * from "./drivingLicense.vue?vue&type=script&lang=js"
import style0 from "./drivingLicense.vue?vue&type=style&index=0&id=6450b1ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450b1ec",
  null
  
)

export default component.exports